// Accepts root-relative paths and http(s) absolute URLs. Blocks javascript:,
// data:, vbscript: and any other scheme that could execute code via href.
export default function isSafeUrl(url) {
  if (typeof url !== 'string' || url.length === 0) return false
  if (url.startsWith('/') && !url.startsWith('//')) return true
  try {
    const parsed = new URL(url)
    return parsed.protocol === 'http:' || parsed.protocol === 'https:'
  } catch {
    return false
  }
}
